import React from 'react';

const JournalTypeForm = ({ isOpen, onClose, onSubmit, formData, setFormData, isEditing }) => {
    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    return (
        <div className="modal-overlay">
            <div className="modal-box" style={{ width: '90%', maxWidth: '600px' }}>
                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '20px', lineHeight: '1.4' }}>
                        {isEditing ? "Cập nhật Loại tạp chí" : "Thêm mới Loại tạp chí"}
                    </h3>
                    <button className="close-btn" onClick={onClose} style={{ fontSize: '26px', lineHeight: '1', flexShrink: 0, marginTop: '-2px' }}>
                        &times;
                    </button>
                </div>
                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="journalForm" onSubmit={onSubmit}>
                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Loại tạp chí <span className="text-red">*</span>
                            </label>
                            <input type="text" name="Name" className="form-input" value={formData.Name} onChange={handleChange} required maxLength="500" />
                        </div>
                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Điểm công trình <span className="text-red">*</span>
                            </label>
                            <input type="number" step="0.1" name="Score" className="form-input" value={formData.Score} onChange={handleChange} />
                        </div>
                        <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                            <input type="checkbox" name="IsRewarded" checked={formData.IsRewarded} onChange={handleChange} style={{ width: '18px', height: '18px', cursor: 'pointer' }} id="isRewarded" />
                            <label htmlFor="isRewarded" style={{ margin: 0, cursor: 'pointer', fontWeight: '500', color: '#2c3e50' }}>
                                Được tính thưởng
                            </label>
                        </div>
                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Nhóm thưởng</label>
                            <select name="RewardGroup" className="form-input" value={formData.RewardGroup} onChange={handleChange}>
                                <option value="Khác">Khác</option>
                                <option value="Nhóm Q1">Nhóm Q1</option>
                                <option value="Nhóm Q2">Nhóm Q2</option>
                                <option value="Nhóm Q3">Nhóm Q3</option>
                                <option value="Nhóm Q4">Nhóm Q4</option>
                            </select>
                        </div>
                        <div className="form-grid-2">
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Tiền thưởng bài báo</label>
                                <input type="number" name="PaperReward" className="form-input" value={formData.PaperReward} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Thưởng tác giả chính</label>
                                <input type="number" name="MainAuthorReward" className="form-input" value={formData.MainAuthorReward} onChange={handleChange} />
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="journalForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default JournalTypeForm;